import updateTree from './updateTree'

export default function lockReason(state = {}, action) {
  switch (action.type) {
    case 'SET_LOCK_REASON':
      return updateTree(state, 'lockReason', () => action.lockReason)

    default:
      return {
        lockReason: null,
        ...state,
      }
  }
}
